import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0461157a")
const _hoisted_1 = {
  key: 0,
  id: "main"
}
const _hoisted_2 = { id: "editor-window" }
const _hoisted_3 = { id: "canvas-top-tool" }
const _hoisted_4 = {
  id: "canvas-wrap",
  ref: "canvasWrap"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_SideToolBar = _resolveComponent("SideToolBar")!
  const _component_ColorPickr = _resolveComponent("ColorPickr")!
  const _component_TopToolBar = _resolveComponent("TopToolBar")!
  const _component_Canvas = _resolveComponent("Canvas")!
  const _component_BottomToolBar = _resolveComponent("BottomToolBar")!
  const _component_MobileHelpers = _resolveComponent("MobileHelpers")!
  const _component_OnBoarding = _resolveComponent("OnBoarding")!
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!
  const _component_ModalManager = _resolveComponent("ModalManager")!

  return (_openBlock(), _createElementBlock("div", null, [
    (Object.entries(_ctx.currentLabel).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_NavBar),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_SideToolBar),
            (_ctx.colorPickr.isOpen)
              ? (_openBlock(), _createBlock(_component_ColorPickr, {
                  key: 0,
                  onSetPickrIsRendered: _ctx.setPickrIsRendered
                }, null, 8, ["onSetPickrIsRendered"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_TopToolBar),
              _createElementVNode("div", _hoisted_4, [
                (_ctx.canvasWrap)
                  ? (_openBlock(), _createBlock(_component_Canvas, { key: 0 }))
                  : _createCommentVNode("", true)
              ], 512),
              (!_ctx.isMobile && _ctx.clientDimensions.width > 767)
                ? (_openBlock(), _createBlock(_component_BottomToolBar, { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isMobile && !_ctx.rulers)
              ? (_openBlock(), _createBlock(_component_MobileHelpers, {
                  key: 1,
                  onToggleLock: _ctx.toggleLock
                }, null, 8, ["onToggleLock"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showOnboarding && !_ctx.isMobile)
      ? (_openBlock(), _createBlock(_component_OnBoarding, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_LoadingScreen),
    _createVNode(_component_ModalManager)
  ]))
}